import { ChangeEvent, useCallback, useState, useEffect } from 'react';

import { utilities } from 'core';
import { useUpdateEffect } from 'ui/hooks';

import type { UseSearchProps } from './SearchInput.d';

export const useSearch = ({ onChangeSearch, onClear, type }: UseSearchProps) => {
  const [searchValue, setSearchValue] = useState('');

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const { value: inputValue } = event.currentTarget;
    setSearchValue(inputValue);
  }, []);

  const handleOnChangeCallback = useCallback(
    utilities.debounce((inputValue: string) => {
      const isTypeText = type === 'text' ? true : inputValue.length > 2;

      if (onChangeSearch && isTypeText) {
        onChangeSearch(inputValue);
      }
    }),
    [],
  );

  const handleClear = useCallback(() => {
    if (onClear) {
      onClear();
    }

    setSearchValue('');
  }, [onClear]);

  useUpdateEffect(() => {
    handleOnChangeCallback(searchValue);
  }, [searchValue, handleOnChangeCallback]);

  useEffect(() => {
    setSearchValue('');
  }, [onClear]);

  return {
    searchValue,
    handleChange,
    handleClear,
  };
};
